import Icon from '@/components/ui/AppIcon';

interface UpcomingItem {
  id: string;
  title: string;
  date: string;
  type: 'appointment' | 'refill' | 'deadline' | 'checkin';
  description: string;
}

interface UpcomingItemsProps {
  items: UpcomingItem[];
}

const UpcomingItems = ({ items }: UpcomingItemsProps) => {
  const getTypeIcon = (type: string) => {
    switch (type) {
      case 'appointment':
        return 'CalendarIcon';
      case 'refill':
        return 'BeakerIcon';
      case 'deadline':
        return 'ClockIcon';
      case 'checkin':
        return 'PhoneIcon';
      default:
        return 'BellIcon';
    }
  };

  const getTypeColor = (type: string) => {
    switch (type) {
      case 'appointment':
        return 'bg-secondary/10 text-secondary';
      case 'refill':
        return 'bg-primary/10 text-primary';
      case 'deadline':
        return 'bg-warning/10 text-warning';
      case 'checkin':
        return 'bg-accent/10 text-accent';
      default:
        return 'bg-muted text-muted-foreground';
    }
  };

  return (
    <div className="space-y-3">
      {items.map((item) => (
        <div
          key={item.id}
          className="flex items-start gap-3 p-3 glass rounded-lg hover:border-primary/30 transition-smooth"
        >
          <div
            className={`flex-shrink-0 w-10 h-10 rounded-lg flex items-center justify-center ${getTypeColor(
              item.type
            )}`}
          >
            <Icon name={getTypeIcon(item.type) as any} size={20} />
          </div>
          <div className="flex-1 min-w-0">
            <div className="flex items-start justify-between gap-2 mb-1">
              <h4 className="text-sm font-caption font-medium text-foreground">
                {item.title}
              </h4>
              <span className="text-xs font-caption text-muted-foreground whitespace-nowrap">
                {item.date}
              </span>
            </div>
            <p className="text-xs font-caption text-muted-foreground">
              {item.description}
            </p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default UpcomingItems;